module.exports = __webpack_public_path__ + "static/media/cd.d277b6df.svg";